export default __webpack_public_path__ + "static/media/Hades_Desktop.fa0696f6.mp4";